import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import { GeoJSONFeature } from "ol/format/GeoJSON";

import RemnantPair from "lib/classes/remnantpair";

interface CookieCutProps {
	newFeatures:Feature<Geometry>[],
	oldFeatures:Feature<Geometry>[]
}

export default class CookieCut implements CookieCutProps {
	public newFeatures:Feature<Geometry>[];
	public oldFeatures:Feature<Geometry>[];
	public remnantPairs:RemnantPair[] = [];
	
	constructor({newFeatures, oldFeatures}:CookieCutProps) {
		this.newFeatures = newFeatures;
		this.oldFeatures = oldFeatures;
	}
}